module.exports = __webpack_public_path__ + "static/media/applicant-group.028e827e.svg";